<div class="checkout-wrapper">
  <div class="order">
    <div
      class="image"
      [ngStyle]="{
        'background-image': 'url(' + encodedMainImage() + ')',
        'background-color': visual?.backgroundColor
      }"
    >
      @if (event?.isMainPictureVideo()) {
        <div class="background-video-cont">
          <video
            class="key-visual-1"
            [muted]="'muted'"
            autoplay
            playsinline
            loop
          >
            <source [src]="event?.mainPictureUrl" type="video/mp4" />
          </video>
        </div>
      }
    </div>
    <div class="order-info">
      <div class="event-info">
        <div class="event-name">
          {{ event?.name }}
        </div>
        <div class="date-wrapper">
          @if (event && event.startDate) {
            {{
              DateUtils.formatEventDateRangeFlexibleWithWeekday(
                event.startDate,
                event.endDate
              )
            }}
          } @else {
            {{ "APP.EVENT.JUST_DATE_TBD" | translate }}
          }
        </div>
      </div>

      <app-order-overview
        [isGeneric]="false"
        [showTitle]="false"
        [showImage]="false"
        [showOrder]="false"
        [ticketOrder]="ticketOrder"
        [mainImage]="mainImage"
        [event]="event"
        [showTotal]="false"
        [disableMobileView]="true"
      />

      @if (isDesktop) {
        @if (ticketOrder?.isProcessing()) {
          <button class="btn btn-primary processing-btn">
            <div class="loader"></div>
            {{ "APP.EVENT_PAYMENT.PAYMENT_PROCESSING" | translate }}
          </button>
        } @else {
          @if (
            ticketOrder &&
            ticketOrder.eventAttendeeTickets &&
            ticketOrder.eventAttendeeTickets.length > 1
          ) {
            <div class="actions">
              <button class="btn btn-primary" (click)="seeAllTickets()">
                <span>
                  {{ "APP.EVENT_PAYMENT.ASSIGN_TICKETS" | translate }}</span
                >
              </button>
              <button class="btn-icon-outline" (click)="seeAllOrders()">
                <i class="fa-regular fa-ticket"></i>
              </button>
            </div>
          } @else {
            <button class="btn btn-primary" (click)="seeTicket()">
              <i class="fa-regular fa-ticket"></i>
              <span>
                {{ "APP.EVENT_PAYMENT.SEE_YOUR_TICKETS" | translate }}</span
              >
            </button>
          }
        }
      }
    </div>
  </div>
</div>
